import React, { useState } from "react";
import "../Styles/Tabbar.css";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { MenuBook, MenuOpen, MenuRounded } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { MessageOutlined, UserOutlined } from "@ant-design/icons";
import "../Styles/Appp.css";

import { Avatar, Flex, Typography } from "antd";
function Tabbar() {
  const [show, setshow] = useState(false);
  const user = useSelector((state) => state.auth.user);
  const nav = useNavigate();
  return (
    <div className="main_header">
      <header className="headerrr">
        <Link to={"/"} className="logo">
          MDOS Billing pro
        </Link>
        <button
          className="menu"
          onClick={() => {
            setshow(!show);
          }}
        >
          {!show ? <MenuRounded /> : <MenuOpen />}
        </button>
        {show && (
          <nav className="nav2">
            <Link to={"/"}>Home</Link>

            {user && <Link to={"/Notesform"}>Fill in Notes Forms</Link>}
            {user && <Link to={"/Dashboard"}>User Dashboard</Link>}
            {!user && <Link to={"/Login"}>User Login</Link>}
          </nav>
        )}
        <nav className="nav">
          {/* <a href="#services" className="item">
          Services
        </a>
        <a href="#address" className="item">
          Address
        </a>
        <a href="#review" className="item">
          Review
        </a> */}
        </nav>
        <div className="auth">
          {!user ? (
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 0, mb: 0, backgroundColor: "#c" }}
              onClick={() => {
                nav("/Login");
              }}
            >
              Login
            </Button>
          ) : (
            <Flex align="flex-end" gap={"0.6rem"}>
              <Button
                className="desktop_show_content notesforms_button"
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 0, mb: 0, backgroundColor: "#F26419" }}
                onClick={() => {
                  nav("/Notesform");
                }}
              >
                Fill in Notes Forms
              </Button>
              {/* <Typography.Title level={5} type="secondary">
                {user.first_name}
              </Typography.Title> */}
              <Link to={"/Dashboard"}>
                <Avatar
                  icon={<UserOutlined />}
                  size="large"
                  className="avatarr"
                />
              </Link>
            </Flex>
          )}
        </div>
      </header>
    </div>
  );
}

export default Tabbar;
